import React from 'react';
import roles from 'helpers/roles';
import { withTranslation } from 'react-i18next';
import getReportFileName from 'helpers/getReportFileName';

import BaseBrandReport from './BaseBrandReport';
import MIME_TYPES from './constants/mimeTypes';

class TotalBel extends React.Component {
  render() {
    const { t } = this.props;
    const title = t('reports.reportTotalBel');

    return (
      <BaseBrandReport
        title={title}
        excelUrl="reports/total-bel"
        mimeType={MIME_TYPES.xlsx}
        fileName={getReportFileName(title)}
        role={roles.ROLE_SHOW_REPORT_TOTAL_BEL}
        excelAvailable={true}
        previewXlsxAvailable={true}
        useMealCategories={true}
        isSalesMarketLangViewEnabled={true}
        reportConfiguration={{
          report: 'TotalBel',
          fields: [
            {
              size: 12,
              field: 'groupAddressStreet',
              inputType: 'select',
              inputProps: {
                multiple: false,
                options: [
                  {
                    value: true,
                    label: this.props.t('common.yes'),
                  },
                  {
                    value: false,
                    label: this.props.t('common.no'),
                  },
                ],
              },
            },
          ],
        }}
        useZoneCategories={true}
        archiveReportNames={['TOTAL_BEL']}
        dateType="single"
      />
    );
  }
}

export default withTranslation()(TotalBel);
